"use client";

import { Button as BaseButton } from "@base-ui/react/button";
import type { VariantProps } from "tailwind-variants";
import { cn } from "@marketing-sites/utils/cn";
import { buttonVariants } from "./button-variants";

export type ButtonProps = BaseButton.Props &
  VariantProps<typeof buttonVariants>;

export function Button({
  className,
  variant,
  size,
  isExternal,
  render,
  ...props
}: ButtonProps) {
  return (
    <BaseButton
      className={cn(buttonVariants({ variant, size, isExternal }), className)}
      render={render}
      nativeButton={render === undefined}
      {...props}
    />
  );
}
